import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rules-web" }
const _hoisted_2 = { key: 1 }

import da from '@/locales/i18n_da.json'
import de from '@/locales/i18n_de.json'
import enGb from '@/locales/i18n_en-GB.json'
import en from '@/locales/i18n_en.json'
import es from '@/locales/i18n_es.json'
import fr from '@/locales/i18n_fr.json'
import nl from '@/locales/i18n_nl.json'
import sv from '@/locales/i18n_sv.json'
import events from '@gd/event-bus'
import { GD, STORE_NAME, Storage } from '@gd/storage'
import merge from 'deepmerge'
import { Component, Ref, VueElement, computed, defineAsyncComponent, ref } from 'vue'
import FairnessGuarantee from './components/FairnessGuarantee.vue'
import GameRulesTabs from './components/GameRulesTabs.vue'
import { supportedGametypes } from './lib/gametypes'
import { useI18n } from 'vue-i18n'

interface Props {
  gametype?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GameRules',
  props: {
    gametype: {}
  },
  setup(__props: any) {

const props = __props;

const { locale, messages, setLocaleMessage, t, te } = useI18n()

const langMap: any = {
  en,
  da,
  de,
  fr,
  es,
  nl,
  'en-GB': enGb,
  sv,
}

const gameTypeMap: any = {
  '1pf': 'pfm',
  '2pf': 'pfm',
  '3pf': 'pfm',
  '4pf': 'pfm',
  mat: 'mah',
  '2wo': 'wos',
  '3wo': 'wos',
}

/**
 * TODO:
 * change i18n-cli tool in a way that it's:
 * * downloads each bundle in source
 * * take the source key and saves each file in format: sourceKey.json -> {en}
 */

const components = {
  sh2: defineAsyncComponent(() => import(/* webpackChunkName: "sh2-rules" */ './components/RuleSh2.vue')),
  so3: defineAsyncComponent(() => import(/* webpackChunkName: "so3-rules" */ './components/RuleSo3.vue')),
  jt2: defineAsyncComponent(() => import(/* webpackChunkName: "jt2-rules" */ './components/RuleJt2.vue')),
  s2l: defineAsyncComponent(() => import(/* webpackChunkName: "s2l-rules" */ './components/RuleS2l.vue')),
  s2i: defineAsyncComponent(() => import(/* webpackChunkName: "s2i-rules" */ './components/RuleS2i.vue')),
  s2p: defineAsyncComponent(() => import(/* webpackChunkName: "s2p-rules" */ './components/RuleS2p.vue')),
  jwl: defineAsyncComponent(() => import(/* webpackChunkName: "jwl-rules" */ './components/RuleJwl.vue')),
  bus: defineAsyncComponent(() => import(/* webpackChunkName: "bus-rules" */ './components/RuleBus.vue')),
  bub: defineAsyncComponent(() => import(/* webpackChunkName: "bub-rules" */ './components/RuleBub.vue')),
  pfm: defineAsyncComponent(() => import(/* webpackChunkName: "pfm-rules" */ './components/RulePfm.vue')),
  wos: defineAsyncComponent(() => import(/* webpackChunkName: "wos-rules" */ './components/RuleWos.vue')),
  mah: defineAsyncComponent(() => import(/* webpackChunkName: "mah-rules" */ './components/RuleMah.vue')),
  ams: defineAsyncComponent(() => import(/* webpackChunkName: "ams-rules" */ './components/RuleAms.vue')),
  bil: defineAsyncComponent(() => import(/* webpackChunkName: "bil-rules" */ './components/RuleBil.vue')),
  bux: defineAsyncComponent(() => import(/* webpackChunkName: "bux-rules" */ './components/RuleBux.vue')),
  cpt: defineAsyncComponent(() => import(/* webpackChunkName: "cpt-rules" */ './components/RuleCpt.vue')),
  cpy: defineAsyncComponent(() => import(/* webpackChunkName: "cpy-rules" */ './components/RuleCpy.vue')),
  drg: defineAsyncComponent(() => import(/* webpackChunkName: "drg-rules" */ './components/RuleDrg.vue')),
  flu: defineAsyncComponent(() => import(/* webpackChunkName: "flu-rules" */ './components/RuleFlu.vue')),
  fre: defineAsyncComponent(() => import(/* webpackChunkName: "fre-rules" */ './components/RuleFre.vue')),
  gos: defineAsyncComponent(() => import(/* webpackChunkName: "gos-rules" */ './components/RuleGos.vue')),
  jw2: defineAsyncComponent(() => import(/* webpackChunkName: "jw2-rules" */ './components/RuleJw2.vue')),
  mpy: defineAsyncComponent(() => import(/* webpackChunkName: "mpy-rules" */ './components/RuleMpy.vue')),
  pol: defineAsyncComponent(() => import(/* webpackChunkName: "pol-rules" */ './components/RulePol.vue')),
  pyr: defineAsyncComponent(() => import(/* webpackChunkName: "pyr-rules" */ './components/RulePyr.vue')),
  maf: defineAsyncComponent(() => import(/* webpackChunkName: "maf-rules" */ './components/RuleMaf.vue')),
  so2: defineAsyncComponent(() => import(/* webpackChunkName: "so2-rules" */ './components/RuleSo2.vue')),
  soh: defineAsyncComponent(() => import(/* webpackChunkName: "soh-rules" */ './components/RuleSoh.vue')),
  spi: defineAsyncComponent(() => import(/* webpackChunkName: "spi-rules" */ './components/RuleSpi.vue')),
  spl: defineAsyncComponent(() => import(/* webpackChunkName: "spl-rules" */ './components/RuleSpl.vue')),
  spp: defineAsyncComponent(() => import(/* webpackChunkName: "spp-rules" */ './components/RuleSpp.vue')),
  swp: defineAsyncComponent(() => import(/* webpackChunkName: "swp-rules" */ './components/RuleSwp.vue')),
  trv: defineAsyncComponent(() => import(/* webpackChunkName: "trv-rules" */ './components/RuleTrv.vue')),
  xwo: defineAsyncComponent(() => import(/* webpackChunkName: "xwo-rules" */ './components/RuleXwo.vue')),
  zoo: defineAsyncComponent(() => import(/* webpackChunkName: "zoo-rules" */ './components/RuleZoo.vue')),
  bel: defineAsyncComponent(() => import(/* webpackChunkName: "bel-rules" */ './components/RuleBel.vue')),
  bel_basic: defineAsyncComponent(() => import(/* webpackChunkName: "bel-rules" */ './components/RuleBelBasic.vue')),
  bel_annonces: defineAsyncComponent(() => import(/* webpackChunkName: "bel-rules" */ './components/RuleBelAnnonces.vue')),
  bel_coinche: defineAsyncComponent(() => import(/* webpackChunkName: "bel-rules" */ './components/RuleBelCoinche.vue')),
  bel_contree: defineAsyncComponent(() => import(/* webpackChunkName: "bel-rules" */ './components/RuleBelContree.vue')),
  bgm: defineAsyncComponent(() => import(/* webpackChunkName: "bgm-rules" */ './components/RuleBgm.vue')),
  dko: defineAsyncComponent(() => import(/* webpackChunkName: "dko-rules" */ './components/RuleDko.vue')),
  dko_official: defineAsyncComponent(() => import(/* webpackChunkName: "dko-rules" */ './components/RuleDkoOfficial.vue')),
  kla: defineAsyncComponent(() => import(/* webpackChunkName: "kla-rules" */ './components/RuleKla.vue')),
  kla_basic: defineAsyncComponent(() => import(/* webpackChunkName: "kla-rules" */ './components/RuleKlaBasic.vue')),
  mau: defineAsyncComponent(() => import(/* webpackChunkName: "mau-rules" */ './components/RuleMau.vue')),
  mau_official: defineAsyncComponent(() => import(/* webpackChunkName: "mau-rules" */ './components/RuleMauOfficial.vue')),
  tar: defineAsyncComponent(() => import(/* webpackChunkName: "tar-rules" */ './components/RuleTar.vue')),
  tar_formal: defineAsyncComponent(() => import(/* webpackChunkName: "tar-rules" */ './components/RuleTarFormal.vue')),
  ska: defineAsyncComponent(() => import(/* webpackChunkName: "ska-rules" */ './components/RuleSka.vue')),
  ska_official: defineAsyncComponent(() => import(/* webpackChunkName: "ska-rules" */ './components/RuleSkaOfficial.vue')),
  ska_kneipenskat: defineAsyncComponent(() => import(/* webpackChunkName: "ska-rules" */ './components/RuleSkaKneipenskat.vue')),
  rom: defineAsyncComponent(() => import(/* webpackChunkName: "rom-rules" */ './components/RuleRom.vue')),
  rom_official: defineAsyncComponent(() => import(/* webpackChunkName: "rom-rules" */ './components/RuleRomOfficial.vue')),
  hts: defineAsyncComponent(() => import(/* webpackChunkName: "hts-rules" */ './components/RuleHts.vue')),
  kno: defineAsyncComponent(() => import(/* webpackChunkName: "kno-rules" */ './components/RuleKno.vue')),
  ruk: defineAsyncComponent(() => import(/* webpackChunkName: "ruk-rules" */ './components/RuleRuk.vue')),
  rum: defineAsyncComponent(() => import(/* webpackChunkName: "rum-rules" */ './components/RuleRum.vue')),
  mbs: defineAsyncComponent(() => import(/* webpackChunkName: "mbs-rules" */ './components/RuleMbs.vue')),
  mjj: defineAsyncComponent(() => import(/* webpackChunkName: "mjj-rules" */ './components/RuleMjj.vue')),
  wiz: defineAsyncComponent(() => import(/* webpackChunkName: "wiz-rules" */ './components/RuleWiz.vue')),
  wiz_official: defineAsyncComponent(() => import(/* webpackChunkName: "wiz-rules" */ './components/RuleWizOfficial.vue')),
  fr2: defineAsyncComponent(() => import(/* webpackChunkName: "fr2-rules" */ './components/RuleFr2.vue')),
  jj2: defineAsyncComponent(() => import(/* webpackChunkName: "jj2-rules" */ './components/RuleJj2.vue')),
}

/**
 * flag to activate the modal mode ( if data-gametype is set in root this will be set to false )
 */
const modal: Ref<boolean | string> = ref(true)

/**
 * please define here all gametypes which are build in the new way
 */
const lobbyRules: Array<string> = supportedGametypes
const showModal = ref(false)
const gt = ref('')
const anchor = ref('')
const loader = ref(true)



Object.keys(langMap).forEach((lang) => {
  const obj = merge(messages.value[lang] || {}, langMap[lang])
  setLocaleMessage(lang, obj)
})
gt.value = props.gametype ? gameTypeMap[props.gametype] || props.gametype : ''
if (gt.value) {
  modal.value = false
}
events.$on('game-rules', ({ gametype, hidePlayButton }) => {
  if (lobbyRules.indexOf(gametype) !== -1) {
    gt.value = gameTypeMap[gametype] || gametype
    showModal.value = true
  } else {
    showModal.value = false
    // open old game rules in the ugly window popup
    const w = window.open(
      '/gd/help/rulesPopup.xhtml?gametype=' + gametype + (hidePlayButton ? '&hidePlayButton=true' : ''),
      'info',
      'width=635,height=600,resizable=yes,scrollbars=yes,toolbar=no,status=no,menubar=no,location=no',
    )
    w?.focus()
  }
})
events.$on('close-modals', () => {
  closeModal()
})

const onTab = (tab: string) => {
  const gtStr = gameTypeMap[tab] || tab
  // avoid scroll to top if active tab is clicked again
  if (gt.value !== gtStr) {
    gt.value = gtStr
    // scroll view to top if tab clicked
    document.querySelector('.modal-content')?.scrollIntoView()
  }
}
/**
 * handle internal links for modal. The format is gametype (optional) followed by an optional anchor
 * e.g.:
 * * bel (gametype only)
 * * bel_annonces#relglés (gametype + anchor)
 * * #reglés (annchor only)
 *
 * @param linkWithOptionalAnchor [gametype]#[anchor]
 */
const onLink = (linkWithOptionalAnchor: string) => {
  const split = linkWithOptionalAnchor.split('#')
  const link = split[0]

  anchor.value = split[1]
  if (link) {
    gt.value = gameTypeMap[link] || link
    // for none modal pages (info&help) we show the new rules in a modal
    showModal.value = true
  }
  if (anchor.value) {
    // need some delay until the DOM is loaded
    setTimeout(() => {
      const element = document.querySelector(`[id$="${decodeURI(anchor.value)}"]`)
      if (element) element.scrollIntoView({ behavior: 'smooth' })
      else console.log('anchor not exists', anchor.value)
    }, 300)
  } else {
    // if no anchor is present we scroll the view to top
    document.querySelector('.modal-content')?.scrollIntoView({ behavior: 'smooth' })
  }
}
/**
 * handle internal links for static page include. The format is gametype (optional) followed by an optional anchor
 * e.g.:
 * * bel (gametype only)
 * * bel_annonces#relglés (gametype + anchor)
 * * #reglés (annchor only)
 *
 * @param linkWithOptionalAnchor [gametype]#[anchor]
 */
const onLinkStatic = (linkWithOptionalAnchor: string) => {
  const split = linkWithOptionalAnchor.split('#')
  const link = split[0]

  anchor.value = split[1]
  if (link) {
    gt.value = gameTypeMap[link] || link
  }
  if (anchor.value) {
    // need some delay until the DOM is loaded
    setTimeout(() => {
      const element = document.querySelector(`[id$="${decodeURI(anchor.value)}"]`)
      if (element) element.scrollIntoView({ behavior: 'smooth' })
      else console.log('anchor not exists', anchor.value)
    }, 300)
  } else {
    // if no anchor is present we scroll the view to top
    document.getElementById('content')?.scrollIntoView({ behavior: 'smooth' })
  }
}

/**
 * simply opens a link in a new tab and give them focus
 */
const onLinkExtern = (link: string) => {
  window.open(link, '_blank', 'noopener')?.focus()
}

const closeModal = () => {
  showModal.value = false
  loader.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_t_progress = _resolveComponent("t-progress")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_modal_content = _resolveComponent("modal-content")!
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (modal.value !== false && modal.value !== 'false' && showModal.value)
      ? (_openBlock(), _createBlock(_component_gd_modal, {
          key: 0,
          onCloseBG: closeModal,
          onCloseESC: closeModal,
          onClose: closeModal
        }, {
          "modal-top": _withCtx(() => [
            _createVNode(GameRulesTabs, {
              gametype: gt.value,
              onTab: onTab
            }, null, 8, ["gametype"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_modal_app, { m: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_modal_layout, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_modal_content, null, {
                      default: _withCtx(() => [
                        (loader.value)
                          ? (_openBlock(), _createBlock(_component_t_progress, {
                              key: 0,
                              absolute: ""
                            }))
                          : _createCommentVNode("", true),
                        (_unref(te)('gameName.text.' + gt.value))
                          ? (_openBlock(), _createBlock(_component_t_text, { key: 1 }, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, _toDisplayString(_unref(t)('rules.main.title', { gameName: _unref(t)('gameName.text.' + gt.value) })), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(), _createBlock(_resolveDynamicComponent(components[gt.value as keyof typeof components]), {
                          onLoaded: _cache[0] || (_cache[0] = ($event: any) => (loader.value = false)),
                          onLink: onLink,
                          onLinkExtern: onLinkExtern
                        }, null, 32)),
                        (_unref(locale) === 'en')
                          ? (_openBlock(), _createBlock(FairnessGuarantee, {
                              key: 2,
                              onClose: closeModal
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (modal.value === false || modal.value === 'false')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (loader.value)
              ? (_openBlock(), _createBlock(_component_t_progress, {
                  key: 0,
                  absolute: ""
                }))
              : _createCommentVNode("", true),
            (_unref(te)('gameName.text.' + gt.value))
              ? (_openBlock(), _createBlock(_component_t_text, { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_unref(t)('rules.main.title', { gameName: _unref(t)('gameName.text.' + gt.value) })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent(components[gt.value as keyof typeof components]), {
              onLoaded: _cache[1] || (_cache[1] = ($event: any) => (loader.value = false)),
              onLink: onLinkStatic,
              onLinkExtern: onLinkExtern
            }, null, 32)),
            (_ctx.$i18n.locale === 'en')
              ? (_openBlock(), _createBlock(FairnessGuarantee, { key: 2 }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})